module.exports = __webpack_public_path__ + "static/a-xx-224-art-b52c961dedc365847ec0549d6c9ca17d.jpg";